<template>
    <div class="multi-field-wrapper">
        <div class="multi-fields">
            <div v-for="contact in contactsList" class="multi-field">
                <CompanyProfilePrivateFormContact
                    :contact="contact"
                    @update:contact="contactUpdated"
                />
                <p>
                    <button
                        @click="removeContact(contact)"
                        type="button"
                        class="form-actions-button remove-field"
                    >
                        <i class="fa fa-trash"></i>
                    </button>
                </p>
            </div>
        </div>
        <p>
            <button
                type="button"
                @click="addContact"
                class="form-actions-button add-field center-button"
            >
                Add Contact
            </button>
        </p>
    </div>
</template>

<script>
import CompanyProfilePrivateFormContact from "@/components/domain/my-profile/company-profile-form/company-profile-private-form-contact.vue";
import { deepCopyObject } from "@/helpers/runtime";
import { contactModelDefaults } from "@/helpers/user";

export default {
    props: ["contacts"],
    emits: ["contacts-change"],
    data() {
        return {
            contactsList: [],
        };
    },
    mounted() {
        this.contactsList = this.contacts;

        if (this.contactsList.length === 0) {
            this.contactsList.push(contactModelDefaults());
        }
    },
    methods: {
        addContact() {
            this.contactsList.push(contactModelDefaults());
        },
        removeContact(contact) {
            this.contactsList = this.contactsList.filter((c) => c !== contact);
            this.$emit("contacts-change", this.contactsList);
        },
        contactUpdated(updatedContact) {
            const contacts = deepCopyObject(this.contactsList);

            for (let index in contacts) {
                if (contacts[index].id === updatedContact.id) {
                    contacts[index] = updatedContact;
                }
            }

            this.$emit("contacts-change", contacts);
        },
    },
    components: {
        CompanyProfilePrivateFormContact,
    },
};
</script>

<style></style>
